import { callResourceFn } from "../core/callResourceFn.js";
export function tapInlineResource(element) {
    return callResourceFn(element.type, element.props);
}
//# sourceMappingURL=tap-inline-resource.js.map